import { Discount } from '../models/serializable/discounts/discount.js';
import { Price } from '../models/serializable/price.js';
import { TicketGiftCard } from '../models/serializable/discounts/ticket-gift-card.js';
import { GiftCardDetails } from '../models/serializable/gift-card/gift-card-details.js';
import { DiscountModifier, DiscountProvider } from './discount-provider.js';
import { DiscountFactory } from '../factories/discount-factory.js';

export class GiftCardDiscountProvider extends DiscountProvider {
  private remainingValue: Price;

  constructor(private readonly giftCard: TicketGiftCard | GiftCardDetails) {
    super();
    this.remainingValue = giftCard.remainingValue;
  }

  findDiscountForMultipleTickets(_ticketId: string, _quantity: number): DiscountModifier | null {
    return null;
  }

  findDiscountForSingleTicket(_ticketId: string): Discount | null {
    return null;
  }

  findDiscountForOrder(orderPrice: Price): Discount | null {
    if(!this.remainingValue.isPositive() ||
        (GiftCardDetails.assertType(this.giftCard) &&
          (!orderPrice.isPositive() || orderPrice.currency !== this.remainingValue.currency))) {
      return null;
    }

    const discount = Price.min(this.remainingValue, orderPrice);
    this.remainingValue = this.remainingValue.difference(discount);

    return DiscountFactory.fromGiftCard(this.giftCard, discount);
  }

  reset(): void {
    this.remainingValue = this.giftCard.remainingValue;
  }
}
